module.exports = __webpack_public_path__ + "img/socore_Img.44c00865.png";